<template>
  <router-link :to="`/profile/factors/${factor.factoR_ID}`" >
    <div class="relative bg-white rounded-xl p-4 mt-4 text-sm text-gray-700  shadow-lg border-2"
         @click="selectFactor" @touchstart="toggleAnimation($event)" @touchend="toggleAnimation">
      <div class="grid grid-cols-2">
      <span class="flex">
        <font-awesome-icon icon="money-bill" class="w-4 h-4 text-ColorNerkh" />
        <span class="mr-1 text-theme-400 font-bold">{{ $helper.priceFormatter(factor.ghabeL_PARDAKHT / 10) }}</span>
      </span>
        <span class="flex items-center">
          <font-awesome-icon icon="user-group" class="h-4 w-4 text-ColorNerkh"/>
        <span class="mr-1">{{ factor.tedad }} نفر</span>
      </span>
      </div>
      <div class="grid grid-cols-2 mt-3">
      <span class="flex">
        <font-awesome-icon icon="location-dot" class="h-4 w-4 text-ColorNerkh"/>
          <span class="mr-1">{{ factor.namE_SALON }}</span>
      </span>
        <span class="flex">
          <font-awesome-icon icon="table"  class="h-4 w-4 text-ColorNerkh"/>
        <span class="mr-1">میز {{ factor.shO_TABLE }}</span>
      </span>
      </div>
      <div class="grid grid-cols-2 mt-3">
      <span class="flex">
        <font-awesome-icon icon="credit-card" class="h-4 w-4 text-ColorNerkh"/>
        <span class="mr-1 font-bold" :class="renderPaymentType()">{{ factor.pardakhT_STATUS }}</span>
      </span>
        <span class="flex">
          <font-awesome-icon icon="clock" class="h-4 w-4 text-ColorNerkh"/>
        <span class="mr-1">{{ factor.timE_FACTOR + ' ' + factor.datE_FACTOR }}</span>
      </span>
      </div>
      <hr class="my-2 border-theme-500">

      <div class="grid grid-cols-2 text-gray-500 text-center">
      <span class="text-green-600" @click.stop.prevent="toggleStatusDialog('farangI_STATUS_Code')"
            @touchstart.stop @touchend.stop>فست فود</span>
        <span class="text-green-600" @click.stop.prevent="toggleStatusDialog('iranI_STATUS_CODE')"
              @touchstart.stop @touchend.stop>ایرانی</span>
      </div>

      <div class="grid grid-cols-2">
      <span class="flex justify-center">
          <span class="mr-1 text-red-600" @click.stop.prevent="toggleStatusDialog('farangI_STATUS_Code')"
                @touchstart.stop @touchend.stop>{{ factor.farangI_STATUS }}</span>
        </span>
        <span class="flex justify-center">
        <span class="mr-1 text-red-600" @click.stop.prevent="toggleStatusDialog('iranI_STATUS_CODE')"
              @touchstart.stop @touchend.stop>{{ factor.iranI_STATUS }}</span>
      </span>
      </div>

    </div>
  </router-link>
  <transition name="fade">
    <div class="fixed flex items-center w-full h-screen bg-gray-500 bg-opacity-50 top-0 right-0 z-20"
         v-if="statusDialog" @click.stop="toggleStatusDialog('')">
      <div class="bg-gray-800 -mt-16 w-2/3 h-2/3 mx-auto rounded-xl text-center text-white leading-10">
        <h1>وضعیت</h1>
        <hr class="my-2">
        <h2 :class="renderStatus(-1)">فاقد چاپ</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(0)">در صف انتظار</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(1)">در حال آماده سازی</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(2)">آماده تحویل</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(3)">تحویل شده</h2>
      </div>
    </div>
  </transition>

</template>

<script>


export default {
  name: "FactorListItem",
  components: {
    
  },
  props: ['factor'],
  data() {
    return {
      statusDialog: false,
      statusType: ''
    }
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('border-yellow-500')
      event.currentTarget.classList.toggle('shadow-lg')
    },
    renderPaymentType() {
      switch (this.factor.pardakhT_TYPE) {
        case 'NoPaid':
          return 'text-theme-300'
        case 'Paid':
          return 'text-green-700'
        case 'Remain':
          return 'text-ColorNerkh'
      }
    },
    toggleStatusDialog(type) {
      if (this.factor[type] !== -2) {
        this.statusDialog = !this.statusDialog
        this.statusType = type
      }
    },
    renderStatus(status) {
      if (status < this.factor[this.statusType]) {
        return "text-green-700"
      } else if (status === this.factor[this.statusType]) {
        return "bg-ColorNerkh"
      }
    },
  }
}
</script>

<style scoped>
</style>